import { Phone, MessageCircle } from "lucide-react";
import { company } from "../mock/mock";

export default function FloatingActions() {
  return (
    <div className="fixed right-4 bottom-6 z-40 flex flex-col gap-3">
      <a
        href={`https://wa.me/91${company.whatsapp}?text=Hello%20Mahalaxmi%20Tape%20Industries%2C%20I%20am%20interested%20in%20your%20products`}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        className="whatsapp-pulse w-12 h-12 rounded-full bg-[#25D366] hover:bg-[#1ebe5a] text-white grid place-items-center shadow-xl transition-colors"
      >
        <MessageCircle size={22} />
      </a>
      <a
        href={`tel:+91${company.phone}`}
        aria-label="Call us"
        className="w-12 h-12 rounded-full bg-[#c8102e] hover:bg-[#9a0c24] text-white grid place-items-center shadow-xl transition-colors"
      >
        <Phone size={20} />
      </a>
    </div>
  );
}
